import React from 'react';

export interface BloqueadoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const BloqueadoIcon: React.FC<BloqueadoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.334 11.813v-4a5 5 0 1 1 10 0v4m-12 0h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2"/>
    </svg>
  );
};

export default BloqueadoIcon;
